/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';

export const CardSectionLayout = styled(SectionLayout)`
  .section-title {
    font-size: 49px;
    line-height: 110%;
  }

  .card-image-text {
    padding-bottom: 0;
  }

  .section-description {
    font-size: 20px;
    max-width: 725px;
    margin: 10px auto 0;
  }

  .subscribe-without-padding {
    margin: 0;

    .section-blog-details-legal-info {
      max-width: 500px;
      margin: 0 auto;

      p {
        color: var(--black-color);
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        line-height: 150%;
        text-align: center;
        margin: 0 auto;
      }
    }

    .section-review-hero--description {
      margin: 0 !important;
    }

    .section-review-hero--subscribe-content {
      margin: 0 !important;
    }

    .section-review-hero--container {
      padding: 40px 0 0;
    }
  }

  .card-container {
    margin-top: 44px;
  }

  .card-row-container {
    display: flex;
    justify-content: center;
    margin: 0 -20px;

    .card-item {
      flex: 1;
      padding: 20px;
      min-width: 0;

      .ant-card-cover {
        padding: 0;
      }

      .ant-card-cover > * {
        overflow: hidden;
      }
    }
  }

  .section-cta {
    text-align: center;
    margin-top: 55px;
  }

  .section-bottom {
    max-width: 725px;
    margin: 56px auto 0;
    padding: 0 28px;
    text-align: center;

    .section-bottom-title {
      width: fit-content;
      margin: 0 auto;
      padding: 0 7px;
      font-size: 39px;
      &:after {
        margin-top: -16px;
        margin-left: -10px;
        height: 10px;
        display: block;
        width: 110%;
        background: #2cb9fb;
        content: '';
      }
    }

    .bottom-logo-wrapper {
      display: flex;
      justify-content: center;
      margin: 28px auto 0;
      align-items: center;

      .logo-content {
        padding: 11px;

        min-width: 200px;
        img {
          max-width: 100%;
          width: 100%;
        }
      }
    }

    .section-bottom-description {
      font-size: 20px;
      margin-top: 15px;
      margin-bottom: 0;
    }
  }
  .button--button {
    margin-top: 50px;

    @media (max-width: 576px) {
      margin: 50px auto 0px;
    }
  }

  @media (max-width: 991px) {
    .section-title {
      font-size: 36px;
      line-height: 44px;
    }

    .section-description {
      font-size: 20px;
    }

    .card-row-container {
      padding: 0;
      margin: 0 -10px;

      .card-item {
        padding: 10px;
      }
    }

    .section-bottom {
      .section-bottom-title {
        font-size: 32px;
      }

      .bottom-logo-wrapper {
        width: 80%;
      }

      .section-bottom-description {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 768px) {
    .card-row-container {
      flex-wrap: wrap;

      .card-item {
        flex: auto;
        width: 50%;

        &.simple-responsive {
          padding: 10px;
        }
      }
    }

    .section-cta {
      margin-top: 40px;
    }
  }

  @media (max-width: 576px) {
    .section-title {
      font-size: 32px;
      line-height: 36px;
      padding: 20px 20px 0;
    }

    .section-description {
      font-size: 18px;
      padding: 0 20px;
    }

    .card-row-container {
      flex-direction: column;
      align-items: center;

      .card-item {
        width: 100%;
      }
    }

    .section-bottom {
      .bottom-logo-wrapper {
        flex-direction: column;
        align-items: center;

        .logo-content {
          padding: 10px;
        }
      }

      .section-bottom-description {
        font-size: 20px;
      }
    }
  }
`;
